<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Custom Data Types</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create Custom Data Type</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          v-bind="pagingOptions"
          mobile-break-point="1264"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <custom-data-type-edit-dialog
          v-model="editedItem"
          :show="showItemEditor"
          @close="showItemEditor = false"
          @input="onSave"
        />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ customDataTypes }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import CustomDataTypeEditDialog from "./CustomDataTypeEditDialog.vue";
import { removeGQLTypename } from "../../../../helpers";
import { ListMixin } from "../../../../mixins/ListMixin";
import DefaultListActions from "../../shared/DefaultListActions.vue";
const CREATE_MUTATION = gql`
  mutation createCustomDataType($input: CustomDataTypeInput!) {
    createCustomDataType(input: $input) {
      id
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateCustomDataType($input: CustomDataTypeInput!) {
    updateCustomDataType(input: $input) {
      id
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteCustomDataType($id: ID!) {
    deleteCustomDataType(id: $id) {
      id
    }
  }
`;
const LIST_QUERY = gql`
  query allCustomDataTypes {
    customDataTypes {
      edges {
        node {
          id
          name
          description
          owner
        }
      }
    }
  }
`;
export default {
  name: "CustomDataTypes",

  mixins: [ListMixin],

  components: {
    CustomDataTypeEditDialog,
    DefaultListActions,
  },

  data() {
    return {
      debug: false,
      showItemEditor: false,
      editedItem: null,
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Owner", value: "owner" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  computed: {
    items() {
      return this.customDataTypes && this.customDataTypes.edges
        ? this.customDataTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedItem = null;
      this.showItemEditor = true;
    },
    onEditItem(item) {
      this.editedItem = item;
      this.showItemEditor = true;
    },
    onDeleteItem(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: { id: item.id },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom Data Type Deleted.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onSave(payload) {
      this.showItemEditor = payload.id ? true : false;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom Data Type Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },
  apollo: {
    customDataTypes: {
      query: LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/cd-types/CustomDataTypes.vue